import { environment } from "../../environments/environment";


export class TableConstants {

    /* Environment */
    public static get env(): string {
        return "";
        //return "prod" + "_";
    }
    public static get fn_rpc(): string {
        //return environment.envName;
        return "rpc/";
    }
    // GET Methods
    public static get CpHouseRelocation(): string {
        return this.env + 'cp_house_relocation';
    }

    public static get CpVendorDetail(): string {
        return this.env + 'cp_vendor_detail';
    }

    public static get CpHouseMaster(): string {
        return this.env + 'cp_house_master';
    }
    public static get CpHouseRequest(): string {
        return this.env + 'cp_house_request';
    }

    public static get ScMetaData(): string {
        return this.env + 'sc_meta_data';
    }

    public static get DaVehicleMaster(): string {
        return this.env + 'da_vehicle_master';
    }

    public static get RncUsers(): string {
        return this.env + 'rnc_users';
    }
    public static get ScTripMaster(): string {
        return this.env + 'sc_trip_master';
    }
    public static get ScUserTrip(): string {
        return this.env + 'sc_user_trip';
    }
    public static get ScSosMaster(): string {
        return this.env + 'sc_sos_master';
    }
    public static get ScSos(): string {
        return this.env + 'sc_sos';
    }
    public static get ScCabMaster(): string {
        return this.env + 'sc_cab_master';
    }
    public static get ScTripPosition(): string {
        return this.env + 'sc_trip_position';
    }

    public static get CpRnUser(): String {
        return this.env + 'cp_rn_user';
    }

    public static get CpVehicleMaster(): string {
        return this.env + 'cp_vehicle_master'
    }
    public static get CpAssignedCar(): string {
        return this.env + 'cp_assigned_car';
    }

    public static get CpCarMaintenance(): string {
        return this.env + 'cp_car_maintenance';
    }
    public static get CpAssignedHome(): string {
        return this.env + 'cp_assigned_home'
    }
    public static get AppFitnessFeedback(): string {
        return this.env + 'app_fitness_feedback';
    }
    public static get CpCarRequest(): string {
        return this.env + 'cp_car_request';
    }
    public static get DaTrips(): string {
        return this.env + 'da_trips';
    }
    public static get CpDriverMaster(): string {
        return this.env + 'cp_driver_master';
    }
    public static get CpDriverFeedback(): string {
        return this.env + 'cp_driver_feedback';
    }
    public static get CpDriverConcern(): string {
        return this.env + 'cp_driver_concern';
    }
    public static get CpAssignedDriver(): string {
        return this.env + 'cp_assigned_driver';
    }
    public static get MiscData(): string {
        return this.env + 'misc_data';
    }
    public static get FuelCardMaster(): string {
        return this.env + 'fuel_card_master';
    }
    public static get FuelCardCredit(): string {
        return this.env + 'fuel_card_credit';
    }
    public static get FuelCardDetail(): string {
        return this.env + 'fuel_card_detail';
    }
    public static get cpRnFcmToken(): string {
        return this.env + 'cp_rn_fcm_token';
    }

    // Function - Multiple Joins
    public static get fngetCarListAll(): string {
        return this.fn_rpc + "get_car_list_all";
    }
    public static get fnGetVehicleMasterQueries(): string {
        return this.fn_rpc + "get_vehicle_master_queries";
    }
    public static get fngetDaVehicleMasterAll(): string {
        return this.fn_rpc + "get_da_vehicle_master_all";
    }
    public static get fngetCpAssignedCarQueries(): string {
        return this.fn_rpc + "get_cp_assigned_car_queries";
    }
    public static get fnGetDaVehicleMaster(): string {
        return this.fn_rpc + "get_da_vehicle_master";
    }

    public static get fngetCpAssignedCar(): string {
        return this.fn_rpc + "get_cp_assigned_car";
    }

    public static get fngetFuelCardCredit(): string {
        return this.fn_rpc + "get_fuel_card_credit_all";
    }
    // function - PATCH Methods

    public static get fnUpdateVendorData(): string {
        return this.fn_rpc + "update_vendor_data";
    }
    public static get fnupdateMasterCar(): string {
        return this.fn_rpc + "update_master_car";
    }
    public static get fnUpdateFuelCardStatus(): string {
        return this.fn_rpc + "update_fuel_card_status";
    }
    public static get fnUpdateCarData(): string {
        return this.fn_rpc + "update_car_data";
    }
    public static get fnUpdateCpRnUser(): string {
        return this.fn_rpc + "update_cp_rn_user";
    }
    public static get fnUpdateRncUserAssignType(): string {
        return this.fn_rpc + "update_rnc_user_assign_type";
    }
    public static get fnUpdateHouseData(): string {
        return this.fn_rpc + "update_house_data";
    }
    public static get fnUpdateAssignHouse(): string {
        return this.fn_rpc + "update_assign_house";
    }
    public static get fnUpdateMasterHouse(): string {
        return this.fn_rpc + "update_master_house";
    }
    public static get fnUpdateMiscData(): string {
        return this.fn_rpc + "update_misc_data";
    }
    public static get fnUpdateDriverFeedbackStat(): string {
        return this.fn_rpc + "update_driver_feedback_stat";
    }
    public static get fnUpdateDriverConcernStat(): string {
        return this.fn_rpc + "update_driver_concern_stat";
    }
    public static get fnUpdateRncUsers(): string {
        return this.fn_rpc + "update_rnc_users";
    }
    public static get fnUpdateScTripMaster(): string {
        return this.fn_rpc + "update_sc_trip_master";
    }
    public static get fnUpdateScUserByTrip(): string {
        return this.fn_rpc + "update_sc_user_by_trip";
    }
    public static get fnUpdateScUserTrips(): string {
        return this.fn_rpc + "update_sc_user_trips";
    }
    public static get fnUpdateScSos(): String {
        return this.fn_rpc + "update_sc_sos";
    }
    public static get fnUpdateWellnessFeedback(): String {
        return this.fn_rpc + "update_wellness_feedback";
    }
    public static get fnUpdateHouseRequestData(): string {
        return this.fn_rpc + "update_house_request_data";
    }
    public static get fnUpdateReHouseRequestData(): string {
        return this.fn_rpc + "update_re_house_request_data";
    }
    public static get fnUpdateCarMaintenanceData(): string {
        return this.fn_rpc + "update_car_maintenance_data";
    }
    public static get fnUpdateRncUserLocation(): string {
        return this.fn_rpc + "update_rnc_user_location";
    }
    public static get fnUpdateScUserTrip(): string {
        return this.fn_rpc + "update_sc_user_trip";
    }
    public static get fnUpdateRncUsersContact(): string {
        return this.fn_rpc + "update_rnc_users_contact";
    }
    public static get fnUpdatePersonalDriverAgency(): string {
        return this.fn_rpc + "update_personal_driver_agency";
    }
    public static get fnUpdateVehicleMaster(): string {
        return this.fn_rpc + "update_vehicle_master";
    }
    public static get fnUpdate_VehicleMaster(): string {
        return this.fn_rpc + "update_vehicle_master_queries";
    }
    public static get fnUpdateVehicleMasterGeoFenceLimit(): string {
        return this.fn_rpc + "update_vehicle_master_geofence_limit";
    }
    public static get fnUpdateRncUserType(): string {
        return this.fn_rpc + "update_rnc_user_type";
    }
    public static get fnUpdateRmTrip(): string {
        return this.fn_rpc + "update_rm_trip";
    }
    public static get fnUpdateAssignCar(): string {
        return this.fn_rpc + "update_assign_car";
    }
    public static get fnUpdateDriverData(): string {
        return this.fn_rpc + "update_driver_data";
    }
    public static get fnUpdateDriverAssignData(): string {
        return this.fn_rpc + "update_driver_assign_data";
    }
    public static get fnUpdateIsTempPassword(): string {
        return this.fn_rpc + "update_is_temp_password";
    }
    public static get fnSurrenderVehicleMaster(): string {
        return this.fn_rpc + "surrender_vehicle_master";
    }
    public static get fnUpdateVehicleMasterStatus(): string {
        return this.fn_rpc + "update_vehicle_master_status";
    }
    public static get fnUpdateReturnAssignedCar(): string {
        return this.fn_rpc + "update_return_assigned_car";
    }
    public static get fnUpdateCpVehicleMaintenance(): string {
        return this.fn_rpc + "update_cp_vehicle_maintenance";
    }
    public static get fnUpdateVendor(): string {
        return this.fn_rpc + "update_vendor";
    }
    public static get fnUpdateCpRnUserdata(): string {
        return this.fn_rpc + "update_cp_rn_userdata";
    }
    public static get fnUpdateDriverConcern(): string {
        return this.fn_rpc + "update_driver_concern";
    }
    public static get fnUpdateFuelMasterCard(): string {
        return this.fn_rpc + "update_fuel_master_card";
    }

    public static get fnUpdateFuelCardDetail(): string {
        return this.fn_rpc + "update_fuel_card_detail";
    }

    public static get fnUpdateFuelMasterCardStatus(): string {
        return this.fn_rpc + "update_fuel_master_card_status";
    }

    public static get fnUpdateFuelCardCredit(): string {
        return this.fn_rpc + "update_fuel_card_credit";
    }

    public static get fngetAssignCarByFuelCardId(): string {
        return this.fn_rpc + "get_cp_assigned_car_by_fuel_card";
    }

    public static get updateAssignedCar(): string {
        return this.fn_rpc + "update_assigned_car";
    }


}